import { updateResult } from './result.action';

export default (state = '', action) => {
  switch (action.type) {
    case String(updateResult):
      return action.payload;
    default:
      return state;
  }
};